import type { Stop } from '#domain/Stop.ts';
import type { StopStatus } from '#domain/StopStatus.ts';

export const TourStopProgress = ({ stops }: { stops: Stop[] }) => {
    if (!stops) {
        return null;
    }
    const width = 100 / stops.length;

    const getStopStyle = (status?: StopStatus) => {
        switch (status) {
            case 'open':
                return '';
            case 'reached':
                return 'progress-bar progress-bar-striped progress-bar-animated progress-bar-info progress-divider';
            case 'finished':
                return 'progress-bar progress-bar-success progress-divider';
        }
    };

    return (
        <div className='progress flex-1-1 margin-top-10'>
            {stops.map(stop => (
                <div
                    key={stop.id + stop.name}
                    className={`${getStopStyle(stop.status)}`}
                    style={{ width: `${width}%` }}
                />
            ))}
        </div>
    );
};
